<template>
  <div>
    <v-alert type="error" :value="canDictId == null">
      Para usar o CAN, primeiro selecione um dicionário para o veículo.
    </v-alert>

    <div class="w-full" v-if="activeVariables != null">
      <div class="d-flex flex-row-nowrap px-4">
        <div class="grow-1 shrink-1">Variável</div>
        <div class="w-4 mono text-right">PGN</div>
        <div class="w-2 mono text-right">S</div>
        <div class="w-2 mono text-right">L</div>
        <div class="w-3 mono text-right">M</div>
        <div class="w-3 mono text-right">D</div>
        <div class="w-2 mono text-right">O</div>
      </div>
      <CANVariableItem
        class="border-top-grey py-2"
        v-for="variable in activeVariables"
        :key="variable.code + '_' + variable.added"
        :variable="variable"
        :selected="value != null && isIdentical(variable, value)"
        @click.native="choose(variable)"
      />
    </div>
  </div>
</template>

<script>
import { CANDict } from '../../../models'
import CANVariableItem from './CANVariableItem.vue'

const props = ['pgn', 'spnStart', 'spnLen', 'multiplier', 'divisor', 'opts']

function isIdentical(a, b) {
  if (a.code != b.code) return false
  if (props.some((p) => a[p] != b[p])) return false
  return true
}

export default {
  components: { CANVariableItem },
  props: {
    canDictId: { type: Number },
    value: {}
  },
  data() {
    return {
      activeVariables: null,
      props
    }
  },
  watch: {
    canDictId() {
      this.fetchData()
    }
  },
  mounted() {
    this.$loading(() => this.fetchData())
  },
  methods: {
    async fetchData() {
      if (this.canDictId != null) {
        let dict = await CANDict.findById(this.canDictId)
        let vars = dict.variables.filter((x) => !x.isInactive)

        // Se temos uma selecionada e nenhuma variável é igual a
        // ela, é porque foi editada depois de ter sido usada.
        if (
          this.value != null &&
          !vars.some((x) => isIdentical(this.value, x))
        ) {
          let curVar = { ...this.value }
          curVar.added = true
          vars.unshift(curVar)
        }

        this.activeVariables = vars
      }
    },
    choose(x) {
      delete x.added
      this.$emit('input', x)
    },
    isIdentical
  }
}
</script>

<style></style>
